"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const spaces = [{
  title: "Kilig Sala",
  description: "Private Dining Room",
  capacity: "10–15 Guests",
  link: "/PrivateDiningPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/kilig_sala_private_dining.png"
}, {
  title: "Bulwagan Bamboo Hall",
  description: "Event Hall",
  capacity: "40–50 Guests",
  link: "/BambooHallPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/bulwagan_bamboo_hall_event_space.png"
}, {
  title: "Kilig Klub",
  description: "Workshop & Kids Venue",
  capacity: "15–20 Guests",
  link: "/WorkshopSpacePage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1505473/img/kilig_klub_creative_workshop.png"
}];
export default function OurSignatureSpaces() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-signature-spaces" className="py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-serif text-foreground mb-6 tracking-tight">
            Our Signature Spaces
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Discover our meticulously designed venues, blending traditional bamboo architecture with modern minimalism to create the perfect backdrop for your intimate and medium-sized gatherings in Ubud.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {spaces.map((space, index) => <div key={space.title} data-index={index} className={`group relative overflow-hidden rounded-2xl bg-card shadow-sm transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${index * 150}ms`
        }}>
              <AspectRatio ratio={4 / 5} className="bg-muted">
                <img src={space.image} alt={`View of ${space.title}`} className="w-full h-full object-cover transition-transform duration-700 ease-in-out group-hover:scale-105" />
              </AspectRatio>

              <div className="absolute inset-x-0 bottom-0 p-6 bg-background/80 backdrop-blur-md border-t border-border/50 transform transition-transform duration-500">
                <div className="flex flex-col gap-4">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <h3 className="text-xl font-semibold text-foreground mb-1">
                        {space.title}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {space.description}
                      </p>
                    </div>
                    <Badge variant="outline" className="bg-background/50 whitespace-nowrap">
                      {space.capacity}
                    </Badge>
                  </div>

                  <Link to={space.link} className="inline-flex items-center gap-2 text-sm font-medium text-primary hover:text-primary/80 transition-colors w-fit group/link">
                    View Detail
                    <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}